import client from '@/util/client'
import * as types from '../mutation-types'

// state
export const state = {
  user: {role: {name: 'guest'}},
  token: null
}

// getters
export const getters = {
  user: state => state.user,
  token: state => state.token,
  check: state => state.token === null
}

// mutations
export const mutations = {
  [types.SAVE_TOKEN](state, {token}) {
    state.token = token
  },

  [types.FETCH_USER_SUCCESS](state, {user}) {
    state.user = user
  },

  [types.FETCH_USER_FAILURE](state) {
    state.token = null
  },

  [types.LOGOUT](state) {
    state.user = {role: {name: 'guest'}}
    state.token = null

  },

  [types.UPDATE_USER](state, {user}) {
    state.user = user
  }
}

// actions
export const actions = {

  async login({commit, dispatch}, payload) {
      return await client.post('/users/user/login', payload).then( (response) => {
        commit(types.SAVE_TOKEN, {token: response.data.access_token})
        return Promise.resolve(response);

      }).catch((error) => {
        return Promise.reject(error);
      })
  },

  async fetchUser({commit}) {
    try {
      const {data} = await client.get('/me')

      commit(types.FETCH_USER_SUCCESS, {user: data})
    } catch (e) {
      commit(types.FETCH_USER_FAILURE)
    }
  },

  updateUser({commit}, payload) {
    commit(types.UPDATE_USER, payload)
  },

  async logout({commit}) {
    try {
      await client.post('/users/user/logout')
      commit(types.LOGOUT)
    } catch (e) {
    }
  }

}
